import React, { createContext, useContext, useState, useCallback, useRef } from "react";
import { fetchMe, logout as apiLogout } from "@/lib/api";

const AuthContext = createContext({ user: null, loading: true, checked: false, refresh: async () => {}, signOut: async () => {} });

// Sign-in is checked lazily (by ProtectedRoute), so public pages never call /api/auth/me.
export function AuthProvider({ children }) {
  const [user, setUserState] = useState(null);
  const [checked, setChecked] = useState(false);

  const inflight = useRef(null);

  const refresh = useCallback(() => {
    if (inflight.current) return inflight.current;
    inflight.current = fetchMe()
      .then((u) => { setUserState(u); return u; })
      .catch(() => { setUserState(null); return null; })
      .finally(() => { setChecked(true); inflight.current = null; });
    return inflight.current;
  }, []);

  const setUser = useCallback((u) => {
    setUserState(u);
    setChecked(true);
  }, []);

  const signOut = useCallback(async () => {
    try { await apiLogout(); } catch (e) {}
    setUserState(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading: !checked, checked, refresh, signOut, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
